import { cloneElement } from 'react';
import { getPlaceId } from '../../lib';

const CheckIfUserHasNotPlaceId = ({ children, ...props }) => {
  return !getPlaceId() ? cloneElement(children, props) : null;
}
export default CheckIfUserHasNotPlaceId;
